import { render } from "./QnaPairAddSectionComp.vue?vue&type=template&id=822b5be8"
import script from "./QnaPairAddSectionComp.vue?vue&type=script&lang=js"
export * from "./QnaPairAddSectionComp.vue?vue&type=script&lang=js"

import "./QnaPairAddSectionComp.vue?vue&type=style&index=0&id=822b5be8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__